var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWhyVenueboostCheck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_60_482)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.95508 16.6797C13.3734 16.6797 16.9551 13.098 16.9551 8.67969C16.9551 4.26141 13.3734 0.679688 8.95508 0.679688C4.5368 0.679688 0.955078 4.26141 0.955078 8.67969C0.955078 13.098 4.5368 16.6797 8.95508 16.6797Z",
    fill: "url(#paint0_linear_60_482)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.97238 8.54709C5.73966 8.31902 5.36234 8.31902 5.12962 8.54709C4.8969 8.77515 4.8969 9.14491 5.12962 9.37299L7.5133 11.709C7.74602 11.9371 8.12333 11.9371 8.35605 11.709L13.1234 7.03699C13.3561 6.80893 13.3561 6.43916 13.1234 6.21109C12.8907 5.98302 12.5134 5.98302 12.2806 6.21109L7.93467 10.4701L5.97238 8.54709Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_60_482",
    x1: 2.9716,
    y1: -9.18211,
    x2: 21.4698,
    y2: -5.39962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0395,
    stopColor: "#240B3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#3D1E59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671382,
    stopColor: "#8319B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9428,
    stopColor: "#BC14FE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_60_482"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.955078 0.679688)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhyVenueboostCheck);
export default __webpack_public_path__ + "static/media/why-venueboost-check.be70c23c1f7a2a676280f5b784554aca.svg";
export { ForwardRef as ReactComponent };